import { findMatrixRowByCode, extractTeamNumber, MATRIX_COLUMNS } from '../matrix';

const customRound = (value) => {
  const decimal = value % 1;
  return decimal >= 0.5 ? Math.ceil(value) : Math.floor(value);
};

/**
 * Рассчитывает KPI команды на основе шагов и матрицы.
 */
export const calculateTeamMetrics = (team, matrix, teamName) => {
  if (!team?.steps?.length) {
    return {
      compliance: 0,
      speed: 0,
      quality: 0,
      patientCentricity: 0,
      digitalMaturity: 0,
    };
  }

  const resolvedTeamName = teamName || team.name;
  const teamNumber = extractTeamNumber(resolvedTeamName);

  let complianceActual = 0;
  let speedActual = 0;
  let qualityActual = 0;
  let patientCentricityActual = 0;
  let digitalMaturityActual = 0;
  let maxPossibleWeight = 0;

  team.steps.forEach((step) => {
    const matrixRow = matrix.find(
      (row) =>
        row[MATRIX_COLUMNS.CODE] === step.code &&
        (!teamNumber || row[MATRIX_COLUMNS.TEAM_NUMBER] === teamNumber)
    ) || findMatrixRowByCode(matrix, step.code, resolvedTeamName);

    if (matrixRow) {
      maxPossibleWeight += 10;
      complianceActual += parseInt(matrixRow[MATRIX_COLUMNS.COMPLIANCE], 10) || 0;
      speedActual += parseInt(matrixRow[MATRIX_COLUMNS.SPEED], 10) || 0;
      qualityActual += parseInt(matrixRow[MATRIX_COLUMNS.QUALITY], 10) || 0;
      patientCentricityActual += parseInt(matrixRow[MATRIX_COLUMNS.PATIENT_CENTRICITY], 10) || 0;
      digitalMaturityActual += parseInt(matrixRow[MATRIX_COLUMNS.DIGITAL_MATURITY], 10) || 0;
    }
  });

  const toPercent = (actual) =>
    maxPossibleWeight > 0 ? customRound((actual / maxPossibleWeight) * 100) : 0;

  return {
    compliance: toPercent(complianceActual),
    speed: toPercent(speedActual),
    quality: toPercent(qualityActual),
    patientCentricity: toPercent(patientCentricityActual),
    digitalMaturity: toPercent(digitalMaturityActual),
  };
};

export { customRound };
